import Player from '@vimeo/player';

document.addEventListener('DOMContentLoaded', () => {
    if (typeof singleVideoData === 'undefined' || !singleVideoData.videoId) return;

    const { videoId, poster } = singleVideoData;
    const wrapper = document.querySelector('.video-wrapper');
    const playerContainer = document.getElementById('playerx');
    const playButton = document.getElementById('play-button');
    const mobileOverlay = document.querySelector('.mobile-overlay');
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    if (!playerContainer) return;

    if (poster && mobileOverlay) {
        mobileOverlay.style.backgroundImage = `url(${poster})`;
        mobileOverlay.style.backgroundSize = 'cover';
        mobileOverlay.style.backgroundPosition = 'center';
    }

    const iframe = document.createElement('iframe');
    iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    iframe.setAttribute('frameborder', '0');
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.position = 'absolute';
    iframe.style.top = '0';
    iframe.style.left = '0';
    iframe.style.objectFit = 'cover';

    iframe.src = `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1&muted=1&loop=1&controls=0&playsinline=1`;

    playerContainer.appendChild(iframe);

    const player = new Player(iframe, {
        id: videoId,
        autopause: false,
        muted: true,
        loop: true
    });

    player.setVolume(0).catch(()=>{});

    if (isMobile) {
        player.pause().catch(()=>{});
        playerContainer.style.display = 'none';

        if (playButton) {
            playButton.addEventListener('click', () => {
                mobileOverlay.style.display = 'none';
                playerContainer.style.display = 'block';
                player.setVolume(1).catch(()=>{}); 
                player.play().catch(()=>{});
            });
        }
    } else {
        player.play().catch((err)=> {
            console.warn('Autoplay bloqueado', err);
        });
    }
});
